import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Plays a YouTube video in a modal. Takes a video id rather than a full URL so
 * the embed URL is always built here, and marks it trusted for the iframe src
 * (Angular strips unsanitised resource URLs otherwise).
 */
@Component({
    selector: 'app-video-modal',
    imports: [],
    templateUrl: './video-modal.component.html',
    styleUrl: './video-modal.component.scss',
})
export class VideoModalComponent implements OnInit {
    @Input() videoId = '';
    @Input() title = 'How it works';

    embedUrl!: SafeResourceUrl;

    constructor(
        public activeModal: NgbActiveModal,
        private sanitizer: DomSanitizer,
    ) { }

    ngOnInit(): void {
        // rel=0 keeps suggestions to this channel, autoplay is safe here because
        // the modal only opens from a user click
        this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0`
        );
    }
}
